<template>
  <Head :title="__('payment-pending.meta.title')">
    <meta
      name="description"
      :content="__('payment-pending.meta.description')"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="order-5">
    <div class="md:container">
      <Link :href="localeRoute('frontend.index')">
        <img
          src="/frontend/assets/logo.svg"
          class="mt-10 hidden lg:block mx-auto"
        >
      </Link>

      <div class="bg-white lg:mt-10 lg:rounded-2xl px-5 py-7 lg:px-20 lg:py-10 lg:mb-8">
        <div class="w-full">
          <div class="text-center border-b border-gray-100 pb-4 lg:w-1/2 lg:mx-auto">
            <h1 class="text-2xl font-bold">
              {{ __('payment-pending.title') }}
            </h1>
          </div>
        </div>

        <div class="mt-8 text-center">
          <h2 class="block text-4xl font-bold lg:text-5xl">
            {{ __('payment-pending.text') }}
          </h2>

          <h3 class="block mt-6 text-2xl font-bold">
            {{ __('payment-pending.flow.title') }}
          </h3>

          <div class="grid grid-cols-1 gap-2 border-b border-gray-100 pb-2 mt-6 md:grid-cols-2 md:gap-6 lg:px-36">
            <div class="">
              <span class="w-[25px] h-[25px] bg-red text-white inline-block rounded-full text-center font-bold mb-2 leading-[1.7]">
                1.
              </span>
              <p class="text-gray-500">
                {{ __('payment-pending.flow.1.title', {vip: vip.first_name}) }}
              </p>
            </div>

            <div class="px-6">
              <span class="w-[25px] h-[25px] bg-red text-white inline-block rounded-full text-center font-bold mb-2 leading-[1.7]">
                2.
              </span>
              <p class="text-gray-500">
                {{ __('payment-pending.flow.2.title') }}
              </p>
            </div>
          </div>
        </div>

        <div class="mt-4 lg:mt-8">
          <div class="px-6 text-center lg:px-60">
            <h2 class="text-2xl font-bold">
              {{ __('payment-pending.promotion.title') }}
            </h2>

            <p class="text-gray-500">
              {{ __('payment-pending.promotion.text') }}
            </p>
          </div>

          <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:mt-8">
            <Vip
              v-for="alternativeVip in alternativeVips"
              :key="`vip-${alternativeVip.username}`"
              :vip="alternativeVip"
              :always-mobile="true"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Clean from '../../Layout/Clean.vue';
import Vip from '../../Components/Vip.vue';

export default {
  components: {
    Vip,
  },

  layout: Clean,

  props: {
    vip: {
      type: Object,
      required: true,
    },

    alternativeVips: {
      type: Array,
      required: true,
    },
  },
};
</script>
